import React from 'react';
import ReactDOM from 'react-dom';
import AppRoot from './components/AppRoot/AppRoot';
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <AppRoot />
  </React.StrictMode>,
  document.getElementById('root')
);
